import '../main'
import csSwitch from './src/switch.vue'

csSwitch.install = function (Vue) {
    Vue.component(csSwitch.name, csSwitch)
}
export default csSwitch


// WEBPACK FOOTER //
// ./src/components/switch/index.js